import { useEffect, useState } from "react";
import NormalTable from "../../../components/common/Tables/NormalTable";
import { getAllVenueBySlug, getReport } from "../../../api";
import { getTicketTypeBySlug } from "../../../api";
import { PulseLoader } from 'react-spinners';
import ExportToExcel from "../../../components/ExportToExcel/ExportToExcel";
import { useNavigate } from "react-router-dom";
import FormattedDate from "../../../components/common/DateFormat/FormattedDate";
import { downloadTicketByBookingNo } from "../../../api";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledDropdown,
  DropdownToggle, 
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
import ExportToPDF from "../../../components/ExportToPdf/ExportToPdf";
import { handleError } from "../../../utils/errorHandler";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

const TicketBuyerDetails = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [phno, setPhno] = useState("");
  const [fullAttendeeList, setFullAttendeeList] = useState<any[]>([]);
  const [attendee, setAttendee] = useState<any[]>([]);
  const [ticketTypes, setTicketTypes] = useState<any[]>([]);
  const [exportTicketData, setExportTicketData] = useState<any[]>([]);
  const [exportAttendeeData, setExportAttendeeData] = useState<any[]>([]);
  const [exportAttendeeDataById, setExportAttendeeDataById] = useState({});
  const [searchParams] = useSearchParams();
  const [downloadingTicket, setDownloadingTicket] = useState(false);
  const [error, setError] = useState("");
  const [reports, setReports] = useState<{ title: string; iconClass: string; ticketSold: string | number; }[]>([
    { title: "Ticket Name", iconClass: "fa-solid fa-ticket fa-2x bg-dark", ticketSold: 0 },
  ]);
  const [bookingList, setBookingList] = useState<any[]>([]);
  const [eventList, setEventList] = useState<any[]>([]);
  const [eventVenues, setEventVenues] = useState<any[]>([]);
  const [selectedVenue, setSelectedVenue] = useState<string>("");
  const location = useLocation();
  const { eventId, ticketTypeId, groupName, ticketType } = location.state || {}; 
    useEffect(() => {
    console.log("Received Props:");
    console.log("eventId:", eventId);
    console.log("ticketTypeId:", ticketTypeId);
    console.log("groupName:", groupName);
    console.log("ticketType:", ticketType);
  }, []);


  const ticketTypeSummaries: {
    title: string;
    iconClass: string;
    ticketSold: string;
    // price: string;
    // total: string;
  }[] = [];
  interface ReportItem {
    title: string;
    iconClass: string;
    ticketSold: string | number;
    // price: string | number;
    // total: string | number;
  }
  const getEventVenue = async (eventId: string) => {
    try {
      const resp = await getAllVenueBySlug(eventId);
      const venueOptions = resp.map((item: any) => {
        return {
          value: item.venueId,
          label: item.venueName
        }
      })
      const allVenue = {
        value: 0,
        label: "All Venues"
      }
      setEventVenues([allVenue, ...venueOptions])
    } catch (error) {
      handleError(error)
    }
  }



 useEffect(() => {
   const fetchData = async () => {
  try {
    setIsLoading(true);

    // ✅ Use values from location.state instead of localStorage
    if (!eventId || !ticketTypeId) return;

    const [reportResponse, ticketTypeResponse, venueResponse] = await Promise.all([
      getReport(eventId),
      getTicketTypeBySlug(eventId),
      getEventVenue(eventId),
    ]);

    if (reportResponse) {
      const paidReports = reportResponse.filter((item: any) =>
        item.paymentStatus === "paid" &&
        item.bookedBy === "0" &&
        (!selectedVenue || item.venueId === selectedVenue)
      );

      const filteredReportResponse = paidReports.filter(
        (item: any) => item?.TicketType?.ticketTypeId === ticketTypeId
      );

      setFullAttendeeList(filteredReportResponse);
      setAttendee(filteredReportResponse);
      setExportAttendeeData(generateExportData(filteredReportResponse));
      setReports([
      {
        title: `${groupName ? `(${groupName}) ` : ""}${ticketType}`,
        iconClass: "fa-solid fa-ticket fa-2x bg-dark",
        ticketSold: filteredReportResponse.length,
      },
    ]);
    }

    if (ticketTypeResponse) {
      setTicketTypes(ticketTypeResponse);
    }
  } catch (error) {
    console.error("Error fetching attendee report:", error);
  } finally {
    setIsLoading(false);
  }
};

    fetchData();
  },
    []);
  const onSelectedVenue = async (e: any) => {
    setIsLoading(true);
    try {
      const selectedVenue = e.target.value;
      const eventData = localStorage.getItem("eventData");
      if (!eventData) return;
      const eventSlug = JSON.parse(eventData).eventId;
      const slugId = JSON.parse(eventData).slugId;
      const reportResponse = await getReport(eventSlug);
      let filteredReportResponse: any[] = [];
      if (selectedVenue !== "0") {
        filteredReportResponse = reportResponse.filter((item: any) => item.paymentStatus === "paid" && item.venueId === selectedVenue);
        setFullAttendeeList(filteredReportResponse);
        setAttendee(filteredReportResponse);
        const exportAttendeeData = generateExportData(filteredReportResponse);
        setExportAttendeeData(exportAttendeeData);
      } else {
        filteredReportResponse = reportResponse.filter((item: any) => item.paymentStatus === "paid");
        setFullAttendeeList(filteredReportResponse);
        setAttendee(filteredReportResponse);
        const exportAttendeeData = generateExportData(filteredReportResponse);
        setExportAttendeeData(exportAttendeeData);
      }
      setSelectedVenue(selectedVenue);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    const filtered = fullAttendeeList.filter((attendee: any) => {
      const name = attendee?.bookingObject?.primaryContactDetails?.firstName?.toLowerCase() || "";
      const emailAddr = attendee?.bookingObject?.primaryContactDetails?.email?.toLowerCase() || "";
      const phone = attendee?.bookingObject?.primaryContactDetails?.phoneNo?.toLowerCase() || "";
      const bookingDate = new Date(attendee?.createdAt);

      const isInDateRange =
        (!fromDate || bookingDate >= new Date(fromDate)) &&
        (!toDate || bookingDate <= new Date(toDate + "T23:59:59"));

      return (
        name.startsWith(search.toLowerCase()) &&
        emailAddr.startsWith(email.toLowerCase()) &&
        phone.replace(/^0+/, '').startsWith(phno.replace(/^0+/, '')) &&
        isInDateRange
      );
    });
    setAttendee(filtered);
  }, [search, email, phno, fullAttendeeList, fromDate, toDate]);


  const generateExportData = (data: any[]) => {
    const exportData: any[] = [];
    data.forEach((item: any) => {
      
      exportData.push({
        firstName: item?.Contact?.firstName || '',
        email: item?.Contact?.email || '',
        phoneNo: item?.Contact?.phoneNo || '',
        bookingNumber: item?.bookingNo || '',
        ticketType: item?.TicketType?.ticketType || '',
        ticketPrice: item?.TicketType?.price || '',
        totalTicketCount: item?.totalTicketCount || '',
        totalTicketAmount: item?.totalTicketAmount || '',
        grandTotal: item?.grandTotal || '',
        bookingDate: item?.createdAt || '',
        venueName: item?.Venue?.venueName || '',
      });
    });
    return exportData;
  }
  const handleDownloadTicket = async (row: any) => {
    try {
      setDownloadingTicket(true);
  
      const bookingNo =
        row?.primaryBookingNo || row?.bookingNo;
  
      if (!bookingNo) {
        throw new Error("Booking number not found");
      }
  
      const response = await downloadTicketByBookingNo(bookingNo);
  
      if (!response) {
        throw new Error("Failed to download ticket");
      }
  
      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (err) {
      handleError(err);
      setError("Failed to download ticket. Please try again.");
    } finally {
      setDownloadingTicket(false);
    }
  };
  const columns = [
    {
      label: "Name", key: "firstName",
      cellContent: (row: any) => {
        return (
          <div>
            <span>{row?.Contact?.firstName}</span><br />
            <span>{row?.Contact?.email}</span><br />
            <span>{row?.Contact?.phoneNo}</span><br />
            <span>{row?.Venue?.venueName}</span>
          </div>
        )
      }
    },
    {
      label: "Ticket Type", key: "ticketType",
      cellContent: (row: any) => <span>{row?.TicketType?.ticketType}</span>
    },
    { label: "Total Ticket Count", key: "totalTicketCount" },
    { label: "Total Ticket Amount", key: "totalTicketAmount" },
    { label: "Grand Total", key: "grandTotal" },
    { label: "Booking Date", key: "createdAt",
      cellContent: (row: any) => <FormattedDate dateString={row?.createdAt} />
     },
     {
      label: "Action",
      key: "action",
      cellContent: (row: any) => (
        row?.bookingStatus === "confirmed" ? (
          <span
            className="text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => handleDownloadTicket(row)}
          >
            <i className="fa-solid fa-download"></i>
            <span className="ms-2">Download Ticket</span>
          </span>
        ) : null
      )
    }
  ];

  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <h3>
                <i className="mx-2">
                  <i className="fa-solid fa-chart-simple "></i>
                </i>
                Attendee Report
              </h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main-card mt-5">
              <div className="dashboard-wrap-content p-4">
                <div className=" flex-wrap align-items-center">
                  <div className="dashboard-date-wrap mt-1">
                    <div className="form-group">

                    <div className="search-container position-relative d-flex flex-column flex-md-row align-items-center gap-3 p-2">
                        {eventVenues.length > 1 && (
                          <div className="search-group position-relative w-100 mb-2 mb-md-0">
                            <select
                              className="form-control h_40 ps-4 text-light"
                              value={selectedVenue}
                              onChange={(e) => onSelectedVenue(e)}
                            >
                              {eventVenues.map((venue: any) => (
                                <option key={venue.value} value={venue.value}>
                                  {venue.label}
                                </option>
                              ))}
                            </select>
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div>
                        )}
                        <div className="search-group position-relative w-100 mb-2 mb-md-0">
                          <input
                            className="form-control h_40 ps-4"
                            type="text"
                            placeholder="Search by name"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                          <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                        </div>
                        <div className="search-group position-relative w-100 mb-2 mb-md-0">
                          <input
                            className="form-control h_40 ps-4"
                            type="text"
                            placeholder="Search by email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                        </div>
                        <div className="search-group position-relative w-100">
                          <input
                            className="form-control h_40 ps-4"
                            type="text"
                            placeholder="Search by phone number"
                            value={phno}
                            onChange={(e) => setPhno(e.target.value)}
                          />
                        </div>
                         <div className=" position-relative w-100">
                          <label>From Date:</label>
                          <input
                            type="date"
                            className="form-control"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                          />
                        </div>
                        <div className=" position-relative w-100">
                          <label>To Date:</label>
                          <input
                            type="date"
                            className="form-control"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                          />
                        </div>  
                        <div className="export-button position-relative w-100">                            
                                <ExportToExcel
                                  data={generateExportData(attendee)}
                                  fileName="Attendee_Report"
                                />
                        </div>
                        {/* <div className="export-button position-relative w-100">
                          <ExportToPDF
                            data={attendee}
                            fileName="Attendee_Report"
                          />
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className="d-flex justify-content-center py-4">
            <PulseLoader color="#ffffff" size={9} speedMultiplier={1} />
          </div>
        ) : (
          <div className="event-list">
            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="orders-tab"
                role="tabpanel"
              >
                {downloadingTicket && (
                  <div
                    className="d-flex align-items-center justify-content-center">
                    <PulseLoader />
                  </div>
                )}
                <NormalTable columns={columns} data={attendee || null} getRowId={(row: any) => row.bookingId} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default TicketBuyerDetails;
